import React from 'react';
import './LoadingSpinner.css';

/**
 * LoadingSpinner component for showing loading states
 * 
 * @param {Object} props - Component props
 * @param {string} props.message - Optional message to display under the spinner
 * @param {string} props.size - Size of the spinner ('small', 'medium', 'large')
 * @param {string} props.containerClassName - Optional additional class for the container
 * @param {boolean} props.fullPage - Whether the spinner should take up the full page
 * @param {string} props.color - Optional color override
 */
const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 'medium',
  containerClassName = '',
  fullPage = false,
  color = null
}) => {
  // Determine spinner size class
  const sizeClass = {
    small: 'loading-spinner-small',
    medium: 'loading-spinner-medium',
    large: 'loading-spinner-large'
  }[size] || 'loading-spinner-medium';
  
  // Dynamic styles for color override
  const spinnerStyle = color ? { borderLeftColor: color } : {};
  
  // Combine container classes
  const containerClasses = `loading-spinner-container ${containerClassName} ${fullPage ? 'loading-spinner-fullpage' : ''}`;
  
  return (
    <div className={containerClasses}>
      <div className={`loading-spinner ${sizeClass}`} style={spinnerStyle}></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;